module.exports = __webpack_public_path__ + "static/media/3.Medical-cosmetology-pictures.80d6616c.png";